<template>
  <div class="item" :class="{inActivate: isInActivate}">
    <div v-if="validateItemQuantity && !validateItemQuantity.result" class="validateStkr">
      {{ validateQuantityMessage }}
    </div>

    <div v-if="cooldown && orderCooldown" class="validateStkr">
      {{ orderCooldownMessage }}
    </div>

    <div class="name">
      <span class="itemName">{{ itemName[lang] }}</span>
      <button type="button" class="btn btnWhite btnDel notranslate" @click.stop="delItem">{{ locale.delete }}</button>
    </div>

    <div v-if="itemOption && itemOption.length > 0" class="option">
      <div class="optionItem">
        <span class="optionName notranslate">{{ locale.base }}</span>
        <span v-if="detailPrice.itemPrice > 0" class="optionPrice">{{ priceFormat(detailPrice.itemPrice) }}</span>
      </div>
      <div
        v-for="(option, index) in itemOption"
        :key="index"
        class="optionItem notranslate"
        :class="{subOptionItem: option.parentOption}">
        <span class="optionName">
          <template v-if="option.isInput">
            {{ option.name[lang] }}: {{ option.value }}
          </template>

          <template v-else>
            {{ option.name[lang] }} ({{ option.quantity }}{{locale.unit_item}})
          </template>
        </span>
        <span v-if="option.price" class="optionPrice">{{ priceFormat(option.price) }}</span>
      </div>
    </div>
    <div class="price notranslate">
      <button v-if="itemOption && itemOption.length > 0" type="button" class="btn btnWhite" @click.stop="setDetailOption(item.cartId)">
        {{ locale.change_option }}
      </button>
      <span class="totalPrice">{{ priceFormat(detailPrice.total) }}</span>
    </div>
    <div class="quantity notranslate">
      <button type="button" class="btnMinus" @click.stop="handleMinus"></button>
      <span class="qty">{{ quantity }}{{ locale.unit_item }}</span>
      <button type="button" class="btnPlus" @click.stop="handlePlus"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shopCartItem',
  props: [
    'locale',
    'lang',
    'item',
    'index',
    'cooldown',
  ],
  components: {
  },
  computed: {
    shopPageId () {
      return this.$route.params.shopPageId
    },
    isExcludeTax () {
      return this.$store.getters['shop/getShopSettings'](this.shopPageId).excludeTax || false
    },
    orderCooldown () {
      const shopPageId = this.shopPageId
      const shopCatCode = this.$store.getters['shop/getShopCatCode'](shopPageId)
      return this.cooldown && this.$store.getters['shop/getWaitingOrder'](shopCatCode)
    },
    orderCooldownMessage () {
      const cooltime = this.orderCooldown
      return cooltime && this.locale.message_order_cooldown.replace('{var}', cooltime)
    },
    itemInfo () {
      return this.item && this.item.payload
    },
    itemName () {
      return this.itemInfo && this.itemInfo.shopItemName
    },
    itemOption () {
      const options = this.itemInfo && this.itemInfo.options
      if (!Array.isArray(options)) return []

      const parents = []
      const childrenByKey = new Map()

      for (const option of options) {
        const isChild = !!option.parentOption
        const baseGroupId = option.id || option.optionId

        option.optionItems.forEach((item, index) => {
          const isInput = Object.prototype.hasOwnProperty.call(item, 'value')

          const row = {
            id: `${baseGroupId}_${index}`,
            groupId: baseGroupId,
            ...(isInput
              ? {
                  isInput: true,
                  name: option.name,
                  value: item.value
                }
              : {
                  optionItemId: item.optionItemId,
                  quantity: item.quantity,
                  name: item.name,
                  ...(item.priceInfo && {
                    price: Number(this.getItemPrice(item.priceInfo)) * Number(item.quantity)
                  })
                })
          }

          if (!isChild) {
            parents.push(row)
          } else {
            const child = {
              ...row,
              parentOption: option.parentOption,
              parentOptionItem: option.parentOptionItem
            }

            const key = `${child.parentOption}_${child.parentOptionItem}`
            const bucket = childrenByKey.get(key) || []

            bucket.push(child)
            childrenByKey.set(key, bucket)
          }
        })
      }

      const result = []

      for (const parent of parents) {
        result.push(parent)

        // input에는 optionItemId가 없으므로 서브옵션 매칭 대상이 아님
        if (!parent.optionItemId) continue

        const key = `${parent.groupId}_${parent.optionItemId}`
        const children = childrenByKey.get(key)

        if (children) {
          result.push(...children)
          childrenByKey.delete(key)
        }
      }

      for (const rest of childrenByKey.values()) {
        result.push(...rest)
      }

      return result
    },
    detailPrice () {
      const details = this.itemInfo
      const itemPrice = Number(details && details.priceInfo && this.getItemPrice(details.priceInfo)) || 0 //상품자체 단가
      const itemQuantity = (details && details.quantity) || 1
      const options = details && details.options && details.options.flatMap(x => x.optionItems)
      const optionTotal = options
        ? options.reduce((sum, item) => {
            return sum +
              Number((item && item.priceInfo && this.getItemPrice(item.priceInfo)) || 0) *
              (Number(item.quantity) || 0)
          }, 0)
        : 0
      return {
        itemPrice: itemPrice,
        itemQuantity: itemQuantity,
        optionPrice: optionTotal,
        total: (itemPrice + optionTotal) * itemQuantity
      }
    },
    itemQuantity () {
      return this.itemInfo && this.itemInfo.selectQuantity
    },
    getHiddenItems () {
      return this.$store.getters['shop/getHiddenItems']
    },
    isDisabledOrderItem () {
      const shopItemId = this.item.shopItemId
      return this.getHiddenItems.includes(shopItemId)
    },
    validateItemQuantity () {
      const shopItemId = this.item.shopItemId
      const selectOptionByQuantity = this.itemInfo.selectOptionByQuantity
      const cartShopItems = this.$store.getters['cart/getCartShopItems'](shopItemId, true) // store용 CartItem이기 때문에 isStore = true
      return selectOptionByQuantity && cartShopItems ? {
        required: cartShopItems.required, // 최소수량
        quantity: cartShopItems.currentQuantity, // 현재 선택한 수량
        remain: cartShopItems.required - cartShopItems.currentQuantity,
        result: cartShopItems.required <= cartShopItems.currentQuantity
      } : null
    },
    validateQuantityMessage () {
      const itemQuantity = this.validateItemQuantity
      const message = itemQuantity && itemQuantity.remain && this.locale.required_more_items.replace('{var}', itemQuantity.remain)
      const current = itemQuantity && itemQuantity.quantity && this.locale.currently_unit.replace('{var}', itemQuantity.quantity)
      return `${message} (${current})`
    },
    isInActivate () {
      const invalidItemQuantity = this.validateItemQuantity && !this.validateItemQuantity.result
      const isCooldownItem = this.cooldown
      return invalidItemQuantity || isCooldownItem
    },
    categoryItemLimit () {
      const catCode = this.$store.getters['shop/getShopCatCode'](this.shopPageId)
      const categoryId = this.item && this.item.payload && this.item.payload.categoryId
      const limitCount = categoryId && this.$store.getters['shop/getCategoryLimitCount'](this.shopPageId, catCode, categoryId)
      return limitCount
    },
    // 실제 선택 가능한 수량 최대치
    possibleMax () {
      const shopPageId  = this.shopPageId
      const shopCatCode = this.$store.getters['shop/getShopCatCode'](shopPageId)
      const shopItemId  = this.item.shopItemId
      const cur = Number(this.quantity) || 1

      // 아이템 자체 한도 (장바구니/빌링 반영됨): 장바구니 이므로 현재 개수를 + 해야함
      const getItemMax = Number(this.$store.getters['shop/getItemPossibleMax'](shopCatCode, shopItemId, true))
      const itemMax = getItemMax + cur

      // 카테고리 한도: 없으면 Infinity 로 처리해 min 계산 시 무시 (장바구니 내 이므로 전체 max를 기준으로 차감해야함, possibleMax가 아닌 max)
      const catRaw = this.categoryItemLimit && this.categoryItemLimit.possibleMax
      const hasCat = catRaw !== null && catRaw !== undefined // 0은 통과
      const catMax = hasCat ? Number(catRaw) + cur: Infinity

      // 둘 중 작은 값 선택, 음수 방지(0 허용), 정수 사용 시 내림
      const minVal = Math.min(itemMax, catMax)
      return Math.max(0, Math.floor(minVal))
    },
  },
  created () {
    if (this.itemInfo) {
      this.quantity = this.itemInfo.quantity
      // this.$emit('updatePrice', { cartId: this.item.cartId, price: this.detailPrice.total })
      this.$store.commit('cart/setItemPrice', { cartId: this.item.cartId, price: this.detailPrice.total })
    }
  },
  watch: {
    detailPrice: {
      deep: true,
      handler (data) {
        const totalPrice = data && data.total
        // this.$emit('updatePrice', { cartId: this.item.cartId, price: totalPrice })
        this.$store.commit('cart/setItemPrice', { cartId: this.item.cartId, price: totalPrice })
      }
    },
    itemQuantity: {
      deep: true,
      handler (data) {
        // if (this.possibleMax === 0) {
        //   this.delItem()
        // }
      }
    },
    quantity (quantity) {
      // const max = this.possibleMax
      // if (quantity > max) {
      //   this.quantity = max
      // }
      this.$store.commit('cart/setItemQuantity', {cartId: this.item.cartId, quantity: this.quantity})
    },
    // 이용시간 지난 템이면?
    isDisabledOrderItem: {
      handler (isDisabled) {
        if (isDisabled) {
          this.delItem()
        }
      },
      immediate: true
    },
    validateItemQuantity: {
      deep: true,
      handler (data) {
        const cartId = this.item.cartId // 인덱스보다 확실한 id가 필요함
        const isValid = (data && typeof data === 'object' && typeof data.result === 'boolean')
          ? data.result
          : true
        this.$emit('isValidItem', cartId, isValid)
      },
      immediate: true
    }
  },
  data () {
    return {
      quantity: 1
    }
  },
  methods: {
    priceFormat (price) {
      const currency = this.$store.getters['shop/getShopCurrency'] || null
      return this.$store.getters['util/getPriceFormatter'](price, currency)
    },
    handlePlus () {
      if (this.itemQuantity) {
        const max = this.possibleMax
        if (max > this.quantity) {
          this.quantity += 1
        }
      }
    },
    handleMinus () {
      if (this.itemQuantity) {
        const requiredMin = this.item.payload.selectOptionByQuantity ? 1 : this.itemQuantity && this.itemQuantity.min
        if (requiredMin < this.quantity) {
          this.quantity -= 1
        }
      }
    },
    delItem () {
      this.$emit('delItem', this.item.cartId)
      // this.$store.commit('cart/delList', cartId)
    },
    setDetail (shopItemId, cartItemId) {
      const itemProperty = this.$store.getters['shop/isItemValid'](shopItemId)
      if (itemProperty) {
        this.$store.commit('shop/setDetailItem', {
          shopItemId: shopItemId,
          categoryId: this.itemInfo.categoryId,
          price: this.getItemPrice(this.itemInfo.priceInfo), // 단가
          pId: this.itemInfo.pId,
          selectQuantity: this.itemInfo.selectQuantity, // 수량
          quantity: this.itemInfo.quantity,
          // 장바구니에서 바로 옵션변경 할 때 필요한 데이터
          ...cartItemId && {
            cartItemId: cartItemId
          },
          ...this.itemInfo.status && {
            status: this.itemInfo.status
          }
        })
      }
    },
    setDetailOption (cartItemId) {
      const shopItemId = this.item.shopItemId
      this.setDetail(shopItemId, cartItemId)
    },
    getItemPrice (priceInfo, price) {
      const excludeTax = this.isExcludeTax
      return priceInfo && (excludeTax ? (priceInfo.net || priceInfo.gross) : priceInfo.gross) || price
    },
  }
}
</script>